var render, staticRenderFns
import script from "./DisputeRaised.vue?vue&type=script&lang=js"
export * from "./DisputeRaised.vue?vue&type=script&lang=js"
import style0 from "./DisputeRaised.vue?vue&type=style&index=0&id=5c29f06e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports